export class Utils {
  static formatPhone(phone: string): string {
    return phone.replace(/\s+/g, '');
  }
}
